import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, ref, watch, onUnmounted, Ref } from 'vue';
import store from '@/store';
import CButton from '@/components/shared/CButton';
import CanvasToolbarTopPreviewButtonsEditModal from '@/components/DesignStudio/CanvasToolbarTop/previews/edit/CanvasToolbarTopPreviewButtonsEditModal.vue';

type Preview = {
    label: string;
    value: string;
    zIndex: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasToolbarTopPreviewButtons',
  setup(__props) {

const isPreMergeFlow = computed(() => !!store.state.storeLayers?.flags?.isPreMergeFlow);

const canModifyPreview = computed(
    () => !store.state.storeLayers?.flags?.hideMultiPreviewActions && !isPreMergeFlow.value
);
const canvas = computed(() => store.state.storeLayers?.canvas);

const selectedPreview: Ref<number | undefined> = ref();
const editModalRef = ref();
const listVersion = ref(0);
const onPreviewListUpdated = () => {
    listVersion.value++;
};

watch(
    () => canvas.value,
    (newCanvas, oldCanvas) => {
        oldCanvas?.off?.('preview:list:updated', onPreviewListUpdated);
        newCanvas?.on?.('preview:list:updated', onPreviewListUpdated);
        listVersion.value++;
    },
    { immediate: true }
);

onUnmounted(() => {
    canvas.value?.off?.('preview:list:updated', onPreviewListUpdated);
});

const listPreview: ComputedRef<Preview[]> = computed(() => {
    listVersion.value;
    return (
        canvas.value?._listPreview?.map((preview) => ({
            label: preview.name,
            value: preview.PreviewId?.toString(),
            zIndex: preview.zIndex
        })) || []
    );
});

const onPreviewSelected = (preview: Preview) => {
    if (!canvas.value) return;
    if (!preview.value) return;
    canvas.value.selectPreview(Number(preview.value));
};

const onEditPreview = (preview: Preview) => {
    if (editModalRef.value) {
        editModalRef.value.openModal(preview);
    }
};

const onDeletePreview = (preview: Preview) => {
    if (!canvas.value) return;
    if (!preview.value) return;
    canvas.value.deletePreview(Number(preview.value));
};

const onSavePreview = (preview: Preview) => {
    if (!canvas.value) return;
    if (!preview.value) return;
    canvas.value.editPreview(Number(preview.value), {
        name: preview.label
    });
};

const getPreviewLabel = (preview: Preview) => {
    return `${preview.zIndex}. ${preview.label}`;
};

watch(
    () => canvas.value?._selectedPreview,
    () => {
        selectedPreview.value = canvas.value?._selectedPreview?.PreviewId;
    }
);

return { __sfc: true,isPreMergeFlow, canModifyPreview, canvas, selectedPreview, editModalRef, listVersion, onPreviewListUpdated, listPreview, onPreviewSelected, onEditPreview, onDeletePreview, onSavePreview, getPreviewLabel, CButton, CanvasToolbarTopPreviewButtonsEditModal }
}

})